import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import { ListItem } from '@mui/material'
import { withStyles } from 'tss-react/mui'
import styles from './EditText.style'
import EditTextField from './EditTextField'

class EditText extends React.PureComponent {
  render() {
    const {
      classes,
      title,
      name,
      hint,
      placeholder,
      autoComplete,
      initialValue,
      ...other
    } = this.props
    return (
      <ListItem disableGutters className={classes.root}>
        <Field
          className={classes.input}
          name={name}
          title={title}
          hint={hint}
          placeholder={placeholder}
          autoComplete={autoComplete}
          initialValue={initialValue}
          component={EditTextField}
          {...other}
        />
      </ListItem>
    )
  }
}

EditText.propTypes = {
  classes: PropTypes.object.isRequired,
  hint: PropTypes.string,
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  autoComplete: PropTypes.string.isRequired,
  initialValue: PropTypes.string,
}

EditText.defaultProps = {
  hint: null,
  initialValue: '',
}
export default (withStyles(EditText, styles))
